import { Component, model, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { PocketGeekContent } from '@assurantlabs/content';
import { PghUserDeviceBase } from '../../device/pgh-user-device';
import { SelectedDeviceService } from '../../device/selected-device.service';
import { DeviceContentApiService } from '../../device-content-api/device-content-api.service';
import { SnackbarService } from 'src/app/core/services/snackbar/snackbar.service';
import { ADPResourceService } from 'digital-core';


@Component({
  selector: 'pgh-device-content-request-modal-window',
  templateUrl: './device-content-request-modal-window.component.html',
  styleUrls: ['./device-content-request-modal-window.component.scss']
})
export class DeviceContentRequestModalWindowComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<DeviceContentRequestModalWindowComponent>,
    private selectedDeviceService: SelectedDeviceService,
    private contentApiService: DeviceContentApiService,
    private snackbarService: SnackbarService,
    public resourceService: ADPResourceService,
  ) { }

  public requestDeviceContentForm: UntypedFormGroup;
  public selectedDevice: PghUserDeviceBase;

  public contentCategoriesSelected: PocketGeekContent.ContentRequestCategory[] = [];
  public subTitle : any;
  ngOnInit(): void {
    this.selectedDevice = this.selectedDeviceService.getSelectedDevice();
    this.subTitle = {Device: `${this.selectedDevice?.make ?? ''} ${this.selectedDevice?.model ?? ''}`.trim()};
    this.requestDeviceContentForm = new UntypedFormGroup({
      manuals: new UntypedFormControl(false),
      videos: new UntypedFormControl(false),
      lifestyle: new UntypedFormControl(false),
      user_comments: new UntypedFormControl('', [Validators.maxLength(180)])
    });
  }

  onCheckboxChanged(event: any) {
    if (event.checked) {
      this.contentCategoriesSelected.push(PocketGeekContent.ContentRequestCategory[event.source.value]);
    } else {
      const index = this.contentCategoriesSelected
        .findIndex(x => x === event.source.value);
      if (index !== -1){
        this.contentCategoriesSelected.splice(index, 1);
      }
    }
  }

  onCancelClicked() {
    this.dialogRef.close({
      data: {
        result: 'cancel',
        ContentRequestRet: null
      }
    });
  }

  onSubmitClicked() {
    const deviceToRequestFor: PocketGeekContent.Device = {
      brand: this.selectedDevice?.make,
      model: this.selectedDevice?.model,
    };
    const userComments = this.requestDeviceContentForm.get('user_comments').value;
    this.contentApiService.requestDeviceContent(deviceToRequestFor, this.contentCategoriesSelected, userComments)
      .then((contentRequest) => {
        this.snackbarService.showSimpleMessage(this.resourceService.getPortaLabelValue("DeviceContentRequest_Modal_Success_Message"));
        console.log(contentRequest.toString());
        this.dialogRef.close({
          data: {
            result: 'success',
            ContentRequestRet: contentRequest
          }
        });
      })
      .catch((error) => {
        this.snackbarService.showSimpleMessage(this.resourceService.getPortaLabelValue("DeviceContentRequest_Modal_Fail_Message").replace(/{Device}/gi, `${this.selectedDevice?.make ?? ''} ${this.selectedDevice?.model ?? ''}`.trim()));
        console.error(error);
        this.dialogRef.close({
          data: {
            result: 'error',
            ContentRequestRet: null
          }
        });
      }
      );
  }
}
